import {
  AddEditContractorDocumentTemplate,
  ContractorDocumentTemplate,
} from "@/models/api/administration/contractors/ContractorDocumentTemplate";
import { UpdateContractorPrintSetting } from "@/models/api/administration/contractors/UpdateContractorPrintSetting";
import CancellableHelper from "@/requests/CancellableHelper";

//#region routes
export const URL_GET_CONTRACTOR_DOCUMENT_TEMPLATES = "/ContractorAdministration/${ContractorId}/DocumentTemplates";
export const URL_POST_ADD_CONTRACTOR_DOCUMENT_TEMPLATE =
  "/ContractorAdministration/${ContractorId}/DocumentTemplate/Add/${DocumentTypeId}";
export const URL_POST_EDIT_CONTRACTOR_DOCUMENT_TEMPLATE =
  "/ContractorAdministration/${ContractorId}/DocumentTemplate/Edit/${Id}";
export const URL_POST_REMOVE_CONTRACTOR_DOCUMENT_TEMPLATE =
  "/ContractorAdministration/${ContractorId}/DocumentTemplate/Remove/${Id}";
export const URL_POST_UPDATE_CONTRACTOR_PRINT_SETTING = "/ContractorAdministration/${ContractorId}/PrintSetting/Update";

//#endregion

const _getContractorDocumentTemplate = new CancellableHelper<Array<ContractorDocumentTemplate>>(
  URL_GET_CONTRACTOR_DOCUMENT_TEMPLATES,
  ContractorDocumentTemplate
);
export const getContractorDocumentTemplates = async (
  contractorId: string
): Promise<Array<ContractorDocumentTemplate>> => {
  return _getContractorDocumentTemplate.get({ ContractorId: contractorId });
};

const _addContractorDocumentTemplate = new CancellableHelper<void>(
  URL_POST_ADD_CONTRACTOR_DOCUMENT_TEMPLATE,
  null,
  true
);
export const addContractorDocumentTemplate = async (
  contractorId: string,
  documentTypeId: number,
  body: AddEditContractorDocumentTemplate
): Promise<void> => {
  return _addContractorDocumentTemplate.post({ ContractorId: contractorId, DocumentTypeId: documentTypeId }, body);
};

const _editContractorDocumentTemplate = new CancellableHelper<void>(
  URL_POST_EDIT_CONTRACTOR_DOCUMENT_TEMPLATE,
  null,
  true
);
export const editContractorDocumentTemplate = async (
  contractorId: string,
  id: number,
  body: AddEditContractorDocumentTemplate
): Promise<void> => {
  return _editContractorDocumentTemplate.post({ ContractorId: contractorId, Id: id }, body);
};

const _removeContractorDocumentTemplate = new CancellableHelper<void>(
  URL_POST_REMOVE_CONTRACTOR_DOCUMENT_TEMPLATE,
  null,
  true
);
export const removeContractorDocumentTemplate = async (contractorId: string, id: number): Promise<void> => {
  return _removeContractorDocumentTemplate.post({
    ContractorId: contractorId,
    Id: id,
  });
};

const _updateContractorPrintSetting = new CancellableHelper<void>(URL_POST_UPDATE_CONTRACTOR_PRINT_SETTING, null, true);
export const updateContractorPrintSetting = async (
  contractorId: string,
  model: UpdateContractorPrintSetting
): Promise<void> => {
  return _updateContractorPrintSetting.post({ ContractorId: contractorId }, model);
};
